import * as yup from "yup";
import {stringRequired} from "yup/defaultValudations";

export const schema = yup.object().shape({
  link: stringRequired(),
});

export const initialValues = {link: ""};
